// Cena da história: slides com fade sobre a tela do jogo (passa sozinho; dá para avançar ou pular).
import { useEffect, useState } from 'preact/hooks';
import type { CutsceneSlide } from '../../../../shared/src/game/quests';

export function Cutscene(props: { slides: CutsceneSlide[]; onEnd: () => void }) {
  const [i, setI] = useState(0);
  const s = props.slides[i];
  const next = () => (i + 1 < props.slides.length ? setI(i + 1) : props.onEnd());
  useEffect(() => {
    const t = setTimeout(next, Math.max(5000, (s?.text.length ?? 0) * 55));
    return () => clearTimeout(t);
  }, [i]);
  if (!s) return null;
  return (
    <div class="cutscene" style={{ background: `radial-gradient(ellipse at center, ${s.tint}e6 0%, #000000f2 75%)` }} onClick={next}>
      <div class="cs-box" key={i}>
        {s.title && <h2>{s.title}</h2>}
        <p>{s.text}</p>
      </div>
      <div class="cs-bar">
        <span>{i + 1} / {props.slides.length}</span>
        <button class="tb-button" onClick={(e) => { e.stopPropagation(); next(); }}>{i + 1 < props.slides.length ? 'Continuar' : 'Fechar'}</button>
        <button class="tb-button" onClick={(e) => { e.stopPropagation(); props.onEnd(); }}>Pular</button>
      </div>
    </div>
  );
}
